import { ACTION_TYPES } from '@/utils/bot-json.constants'

// PRO-740: the form has one Instructions field. Two older fields are folded into it — shown that way in the editor,
// and merged for real on the action's next edit:
//  - `userPrompt`, appended as its own paragraph;
//  - `productRecommendation.relevantInformation`, as the sentence the engine used to build from it, so the model
//    reads the same words.
// The engine keeps reading both fields, so an action nobody edits again behaves exactly as before.
export function mergeLegacyPrompts(action) {
  if (!action) return action

  // only a live section counts — the engine ignores whatever a switched-off section still carries
  const relevantInformation = action.productRecommendation?.enabled === true ?
    action.productRecommendation.relevantInformation?.trim() :
    ''
  if (!action.userPrompt && !relevantInformation) return action

  const relevantInformationSentence = relevantInformation ?
    `Depending on the request, relevant information may include ${relevantInformation.replace(/\.$/, '')} or other preferences.` :
    ''
  const prompt = [action.prompt, action.userPrompt, relevantInformationSentence].filter(Boolean).join('\n\n')
  const merged = { ...action, prompt, userPrompt: '' }
  if (relevantInformation) merged.productRecommendation = { ...action.productRecommendation, relevantInformation: '' }
  return merged
}

// PRO-740: "AI: Product recommendations" is a chatgpt-custom action with the recommendation section on — the
// flag is the action type as far as the form is concerned.
export function isProductRecommendationAction(action) {
  return action?.type === ACTION_TYPES.CHAT_GPT_CUSTOM && action.productRecommendation?.enabled === true
}
